import { createAsyncThunk } from "@reduxjs/toolkit";
import { IEmployeeProfileResponse } from "models/Employee/employeeProfile.model";
import { ITokenModel } from "models/Login/token.model";

import { EmployeeProfileInfo } from "services/employeeProfile.service";

// for Employee Profile Page
export const employeeAsync = createAsyncThunk(
  "Employee",
  async (empReq: ITokenModel): Promise<IEmployeeProfileResponse> => {
    try {
      const response = await EmployeeProfileInfo(empReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
